import * as actions from './actionTypes';

const initialState = {
    notification: null,      // Данные об уведомлении
    sectorsWithProjects: {   // Сферы с проектами
        data: [],
        loading: false,
        error: null
    },
    categories: {
        all: { // Краткая информация о всех категориях
            data: [],
            loading: false,
            error: null
        },     
        top: { // Топ-4 категории для отображения на главной странице
            data: [],
            loading: false,
            error: null
        }      
    },
    currentProduct: { // Информация по выбранному товару
        data: null,
        loading: false,
        error: null
    },
    productList: { // Список товаров
        data: {
            items: [],
            totalItems: 0,
            currentPage: 1,
            pageSize: 9,
            totalPages: 0,
        },
        loading: false,
        error: null
    },
    auth: { // Данные авторизации
        token: localStorage.getItem('token'),
        isAuthenticated: !!localStorage.getItem('token'),
        loading: false,
        error: null
    }
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        // --- Уведомление ---
        case actions.SHOW_NOTIFICATION:
            return {
                ...state,
                notification: action.payload
            };
        case actions.CLEAR_NOTIFICATION:
            return {
                ...state,
                notification: null
            };

        // --- Сферы с проектами ---
        case actions.FETCH_SECTORS_REQUEST:
            return {
                ...state,
                sectorsWithProjects: {
                    ...state.sectorsWithProjects,
                    loading: true,
                    error: null
                }
            };
        case actions.FETCH_SECTORS_SUCCESS:
            return {
                ...state,
                sectorsWithProjects: {
                    data: action.payload,
                    loading: false,
                    error: null
                }
            };
        case actions.FETCH_SECTORS_FAILURE:
            return {
                ...state,
                sectorsWithProjects: {
                    ...state.sectorsWithProjects,
                    loading: false,
                    error: action.payload
                }
            };

        // --- Категории (все) ---
        case actions.FETCH_CATEGORIES_ALL_REQUEST:
            return {
                ...state,
                categories: {
                    ...state.categories,
                    all: { ...state.categories.all, loading: true, error: null }
                }
            };
        case actions.FETCH_CATEGORIES_ALL_SUCCESS:
            return {
                ...state,
                categories: {
                    ...state.categories,
                    all: { data: action.payload, loading: false, error: null }
                }
            };
        case actions.FETCH_CATEGORIES_ALL_FAILURE:
            return {
                ...state,
                categories: {
                    ...state.categories,
                    all: { ...state.categories.all, loading: false, error: action.payload }
                }
            };

        // --- Категории (топ) ---
        case actions.FETCH_CATEGORIES_TOP_REQUEST:
            return {
                ...state,
                categories: {
                    ...state.categories,
                    top: { ...state.categories.top, loading: true, error: null }
                }
            };
        case actions.FETCH_CATEGORIES_TOP_SUCCESS:
            return {
                ...state,
                categories: {
                    ...state.categories,
                    top: { data: action.payload, loading: false, error: null }
                }
            };
        case actions.FETCH_CATEGORIES_TOP_FAILURE:
            return {
                ...state,
                categories: {
                    ...state.categories,
                    top: { ...state.categories.top, loading: false, error: action.payload }
                }
            };
        case actions.UPDATE_CATEGORIES_ORDER:
            return {
                ...state,
                categories: {
                    ...state.categories,
                    all: {
                        ...state.categories.all,
                        data: state.categories.all.data.map(category => {
                            const orderInfo = action.payload.find(item => item.id === category.id);
                            return orderInfo ? { ...category, displayOrder: orderInfo.displayOrder } : category;
                        }).sort((a, b) => a.displayOrder - b.displayOrder)
                    }
                }
            };

        // --- Продукт по ID ---
        case actions.FETCH_PRODUCT_BY_ID_REQUEST:
            return {
                ...state,
                currentProduct: { ...state.currentProduct, loading: true, error: null }
            };
        case actions.FETCH_PRODUCT_BY_ID_SUCCESS:
            return {
                ...state,
                currentProduct: { data: action.payload, loading: false, error: null }
            };
        case actions.FETCH_PRODUCT_BY_ID_FAILURE:
            return {
                ...state,
                currentProduct: { ...state.currentProduct, data: null, loading: false, error: action.payload }
            };
        case actions.CLEAR_CURRENT_PRODUCT:
            return {
                ...state,
                currentProduct: { data: null, loading: false, error: null }
            };
        
        // --- Список продуктов ---
        case actions.FETCH_PRODUCT_LIST_REQUEST:
            return {
                ...state,
                productList: { ...state.productList, loading: true, error: null }
            };
        case actions.FETCH_PRODUCT_LIST_SUCCESS:
            return {
                ...state,
                productList: { data: action.payload, loading: false, error: null }
            };
        case actions.FETCH_PRODUCT_LIST_FAILURE:
            return {
                ...state,
                productList: { ...state.productList, loading: false, error: action.payload }
            };

        // --- Авторизация ---
        case actions.LOGIN_REQUEST:
            return {
                ...state,
                auth: {
                    ...state.auth,
                    loading: true,
                    error: null
                }
            };
        case actions.LOGIN_SUCCESS:
            return {
                ...state,
                auth: {
                    token: action.payload.token,
                    isAuthenticated: true,
                    loading: false,
                    error: null
                }
            };
        case actions.LOGIN_FAILURE:
            return {
                ...state,
                auth: {
                    token: null,
                    isAuthenticated: false,
                    loading: false,
                    error: action.payload
                }
            };
        case actions.LOGOUT:
            return {
                ...state,
                auth: {
                    token: null,
                    isAuthenticated: false,
                    loading: false,
                    error: null
                }
            };

        default:
            return state;
    }
}